module.exports = function (app, link_self) {
  var data = link_self.data;
  var game = data.name || data.game;
  var html = "\n      <div class=\"saito-share-link\">\n         <h2 class=\"saito-modal-title\">Share Options</h2>\n         <div class=\"saito-modal-content saito-menu-select-heavy\">\n           <div id=\"copy-invite-link\" class=\"saito-modal-menu-option\"><i class=\"fas fa-link\"></i><div class=\"saito-modal-menu-option-label\">Copy ".concat(game, " Link</div></div>");

  // Check if Chat / RedSquare installed
  if (link_self.share_to_chat) {
    var chat_mod = app.modules.returnModuleBySlug('chat');
    if (chat_mod !== null && chat_mod !== void 0 && chat_mod.communityGroupName) {
      html += "<div id=\"chat-invite-link\" class=\"saito-modal-menu-option\"><i class=\"fas fa-comments\"></i><div class=\"saito-modal-menu-option-label\">Share Link in ".concat(chat_mod.communityGroupName, "</div></div>");
    }
  }
  if (link_self.share_to_redsquare) {
    var rs_mod = app.modules.returnModuleBySlug('redsquare');
    if (rs_mod) {
      html += "<div id=\"tweet-invite-link\" class=\"saito-modal-menu-option\"><i class=\"".concat(rs_mod.icon_fa, "\"></i><div class=\"saito-modal-menu-option-label\">Tweet to ").concat(rs_mod.returnName(), "</div></div>");
    }
  }
  if (link_self.share_to_qr) {
    html += "<div id=\"qr-invite-link\" class=\"saito-modal-menu-option\"><i class=\"fa-solid fa-qrcode\"></i><div class=\"saito-modal-menu-option-label\">Generate QR code</div></div>";
  }
  html += "</div>\n      </div>\n    ";
  return html;
};